export default "__VITE_ASSET__aqr8s5J1__"